<script>
import {h} from 'vue';
import ArticleContact from '@/components/article/ArticleContact.vue';
import ArticleHomeHero from '@/components/article/ArticleHomeHero.vue';
import ArticleHomeImage from '@/components/article/ArticleHomeImage.vue';
import ArticleTerms from '@/components/article/ArticleTerms.vue';

export default {
    // https://stackoverflow.com/questions/70957780/how-i-can-render-a-component-from-a-string-with-vue-3
    props: {
        html: {
            type: String,
            default: '',
        },
    },
    render() {
        const r = {
            components: {
                ArticleContact,
                ArticleHomeHero,
                ArticleHomeImage,
                ArticleTerms,
            },
            template: `
                <div class="content-compiled">${this.html || ''}</div>`,
            /**
            methods: {
                hello () {
                    // method "hello" is also available here
                },
            },
            **/
        };
        return h(r);
    },
};
</script>
